import { sortBy } from 'lodash';
import React from 'react';
import LoadSpeakers from '../../../../loaders/LoadSpeakers';
import SpeakerItem from './SpeakerItem';

const SpeakersList = props => {
    const {event, session} = props,
        speakers = sortBy(session.speakers, 'in_item_order');

    return (
        <LoadSpeakers eventId={event.id}>
            <ul className="list marginTop marginBottom">
                {speakers.map((speaker, i) => (
                    <SpeakerItem event={event} speaker={speaker} key={i} />
                ))}
            </ul>
        </LoadSpeakers>
    );
};

export default SpeakersList;
